import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=aa0ae806&scoped=true&"
import script from "./Code.vue?vue&type=script&lang=ts&"
export * from "./Code.vue?vue&type=script&lang=ts&"
import style0 from "./Code.vue?vue&type=style&index=0&id=aa0ae806&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0ae806",
  null
  
)

export default component.exports